module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"more":"More information"},"lt":{"meta":{"title":{"complement":"Nogrid","inner":"Paskolos saulės elektrinėms","separator":"-"}},"more":"Daugiau informacijos","ctaLuminor":"Pildyti paraišką"},"pl":{"more":"Więcej informacji"}}')
  delete Component.options._Ctor
}
